<template>
    <div id="app-container">
        <div id="extension-payment-placeholder-storePaymentGroup" class=" box-payment-option">
            <div class="">
                <div>
                    <div style="background-color: rgb(255, 230, 230); padding: 20px; margin: 0px 0px 20px;">
                        <div style="display: flex; flex-direction: row; align-items: center;">
                            <span style="margin-right: 10px;">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM11.5 10.1L10.1 11.5L8 9.4L5.9 11.5L4.5 10.1L6.6 8L4.5 5.9L5.9 4.5L8 6.6L10.1 4.5L11.5 5.9L9.4 8L11.5 10.1Z" fill="#FF4C4C"></path></svg>
                            </span>
                            <p style="margin: 0px; line-height: normal;">
                                Meio de pagamento exclusivo para vendas na Loja.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped src="@/assets/css/checkout-paymentcreditcard.module.css"></style>
<script>
    import formatter from "@/mixins/formatter.js";
    export default {
        name: 'payment-store',
        props: ['enablePaymentButton'],
        mixins: [formatter],
        data: () => ({
            paymentStore: {
            },
        }),
        mounted() {

        },
        computed: {
        },
        methods: {
            getData() {
                this.enablePaymentButton(true);
            }
        }
    }
</script>

